import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const initialAuthState = () => {
    const storedRoles = localStorage.getItem("role");
    const storedAuth = {
      isAuthenticated: localStorage.getItem("isAuthenticated") === "true",
      roles: storedRoles ? JSON.parse(storedRoles) : [],
      userEmail: localStorage.getItem("user") || "",
      accessToken: localStorage.getItem("authorization") || "",
    };
    return storedAuth;
  };

  const [auth, setAuth] = useState(initialAuthState);

  const login = (userData) => {
    setAuth({
      accessToken: userData.authorizationToken,
      isAuthenticated: true,
      userEmail: userData.email,
      roles: userData.roles,
    });
  };

  const logout = () => {
    setAuth({
      accessToken: null,
      isAuthenticated: false,
      userEmail: null,
      roles: [],
    });
    localStorage.clear();
  };

  useEffect(() => {
    localStorage.setItem("authorization", auth.accessToken);
    localStorage.setItem("user", auth.userEmail);
    localStorage.setItem("role", JSON.stringify(auth.roles));
    localStorage.setItem("isAuthenticated", auth.isAuthenticated);
  }, [auth.accessToken, auth.userEmail, auth.roles, auth.isAuthenticated]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
